import React, { useState, useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';

// Redux
import { apiGetCommsRequest, apiCommsDeleteRequest, resetChannelInitialState } from 'Redux/actions/channel';

// styles
import { MainContainer, Header, Title, SubTitle, EmptyIntegrationCardContainer, EmptyIntegrationCard } from './styles';
import { EachCollabolatorsP2P } from 'Pages/ArchiveProjectsPage/styles';
import { CloseIcon, NavTitle, RightNavContainer, SideBarContent, } from 'Layouts/ProjectLayout/styles';
import DashboardLayout from 'Layouts/DashboardLayout';

// Components
import DocumentCard from 'Components/DocumentCard';
import X from 'Components/Icons/X';
import Loader from 'Components/Loader';
import { OutlinedButton } from 'Components/IconButton/styles';
import Plus from 'Components/Icons/Plus';
import { ModalFooter } from 'Components/CommonStyles';
import Modal from 'Components/Modal';
import ProjectIntegrationSidebarContent from 'Components/ProjectIntegrationSidebarContent';

// SVG, PNG
import errorIcon from 'Assets/icons/errorIcon.svg';
import tutorialCommsBg from 'Assets/images/tutorialCommsBg.png';

// Other
import { getObjectByLowestValue } from 'Utils/permissions';
import * as types from 'Config/permissionConstant';
import { OrgIntegrations, ProjectIntegrationsPageSideNavType, IntegrationDeleteModalTypes } from 'Config/integrationsConstant';

const ProjectIntegrationsPage = () => {
	const { project_id } = useParams();
	const dispatch = useDispatch();

	// useSelector
	const channelState = useSelector(state => state.channel);
	const auth = useSelector(state => state.auth);
	const sidebarState = useSelector(state => state.sidebar);
	const selectProjectDetails = sidebarState?.selectedProject;
	const allowedPermissions = selectProjectDetails && getObjectByLowestValue(selectProjectDetails?.permission_obj, 'role')?.allowed_permissions;
	const projectComms = channelState?.projectComms;

	// useState
	const [modalShow, setModalShow] = useState(false);
	const [modalDetails, setModalDetails] = useState(IntegrationDeleteModalTypes['discord']);
	const [selectedDeleteItemId, setSelectedDeleteItemId] = useState(null);
	const [showRightNav, setShowRightNav] = useState(false);
	const [sideNavPage, setSideNavPage] = useState(null);
	const [commsId, setCommsId] = useState(null);

	const deleteClicked = () => {
		dispatch(apiCommsDeleteRequest(selectedDeleteItemId, auth.token, project_id));
		setModalShow(false);
	};

	const onRightNavClose = () => {
		setShowRightNav(false);
	};

	const onModalClose = () => {
		setModalShow(false);
	};

	const handleAddBtnClick = () => {
		setCommsId(null);
		setShowRightNav(true);
		setSideNavPage('ADD_INTEGRATIONS');
	};

	const handleDeleteCommsBtnClick = (projectCommLink) => {
		setModalShow(true);
		setModalDetails(IntegrationDeleteModalTypes[projectCommLink.type]);
		setSelectedDeleteItemId(projectCommLink.id);
	};

	const handleEditClick = (projectCommLink) => {
		setSideNavPage('EDIT_INTEGRATIONS');
		setShowRightNav(true);
		setCommsId(projectCommLink.id);
	};

	const modalFooter = (
		<ModalFooter>
			<Button onClick={onModalClose} variant="light">
				Cancel
			</Button>
			<Button onClick={deleteClicked} variant="danger">
				Delete
			</Button>
		</ModalFooter>
	);

	useEffect(() => {
		dispatch(apiGetCommsRequest(project_id, auth.token));
		return () => {
			dispatch(resetChannelInitialState());
		};
	}, []);

	return (
		<DashboardLayout>
			{ project_id === '0' ? (
				<img src={tutorialCommsBg} className='img-fluid mt-4'/>
			) : (
				<MainContainer>
					<Header>
						<div>
							<Title>
								Integrations and connected apps
							</Title>
							<br />
							<SubTitle>
								Supercharge your workflow and connect the tool you use every day.
							</SubTitle>
						</div>
						{allowedPermissions?.includes(types.ADD_COMMS) && (
							<OutlinedButton
								className="btn btn-sm fw-semibold"
								style={{ minWidth: '145px', color: '#344054' }}
								onClick={handleAddBtnClick}
							>
								<Plus stroke="#344054" /> Add New
							</OutlinedButton>
						)}
					</Header>

					{(channelState?.isLoading ) ? (
						<Loader />
					) : (
						<div
							className="row gy-3"
							style={{ marginTop: '48px', marginBottom: '75px' }}
						>
							{allowedPermissions && allowedPermissions[0] !== types.NO_PERMISSION && (
								projectComms?.length > 0 ? (
									projectComms.map(projectCommLink => OrgIntegrations[projectCommLink.type] !== undefined && (
										<div className="col-lg-6 col-xl-4" key={projectCommLink.id}>
											<DocumentCard
												btnTitle={'Open'}
												image={OrgIntegrations[projectCommLink.type]?.image}
												title={OrgIntegrations[projectCommLink.type]?.name}
												description={OrgIntegrations[projectCommLink.type]?.description}

												subTitle={projectCommLink.title}
												key={projectCommLink.id}
												url={projectCommLink.url}

												deleteAction={allowedPermissions.includes(types.DELETE_COMMS) && (
													<EachCollabolatorsP2P
														onClick={() => handleDeleteCommsBtnClick(projectCommLink)}
														role="button"
													>
														Delete
													</EachCollabolatorsP2P>
												)}
												editAction={allowedPermissions.includes(types.EDIT_COMMS) && (
													<button
														className="btn btn-projectCommLink text-decoration-none"
														onClick={() => handleEditClick(projectCommLink)}
														rel="noopener noreferrer"
													>
														Edit
													</button>
												)}
											/>
										</div>
									))
								) : (
									<EmptyIntegrationCardContainer>
										<EmptyIntegrationCard>No Integrations In This Project Yet</EmptyIntegrationCard>
									</EmptyIntegrationCardContainer>
								)
							)}
						</div>
					)}

					{showRightNav && (
						<RightNavContainer style={{ position: 'fixed', top: '0', right: '0' }}>
							<CloseIcon onClick={onRightNavClose}>
								<X />
							</CloseIcon>
							<NavTitle>
								{ProjectIntegrationsPageSideNavType[sideNavPage]?.title}
								<br />
								<span>{ProjectIntegrationsPageSideNavType[sideNavPage]?.subTitle}</span>
							</NavTitle>
							<SideBarContent>
								<ProjectIntegrationSidebarContent
									onRightNavClose={onRightNavClose}
									projectId={project_id}
									selectedIntegrationId={commsId}
								/>
							</SideBarContent>
						</RightNavContainer>
					)}
				</MainContainer>
			)}
			<Modal
				show={modalShow}
				onHide={onModalClose}
				icon={errorIcon}
				title={modalDetails.title}
				body={modalDetails.body}
				footer={modalFooter}
			/>
		</DashboardLayout>
	);
};

export default ProjectIntegrationsPage;
